import { gql } from '@apollo/client';

export const FINANCE_COST_RULE_FIELDS = `
  id
  label
  category
  amount
  frequency
`;

export const FINANCE_COST_SETTINGS_FIELDS = `
  rules {
    ${FINANCE_COST_RULE_FIELDS}
  }
`;

export const GET_FINANCE_COST_SETTINGS = gql`
  query GetFinanceCostSettings {
    getFinanceCostSettings {
      ${FINANCE_COST_SETTINGS_FIELDS}
    }
  }
`;

export const UPDATE_FINANCE_COST_SETTINGS = gql`
  mutation UpdateFinanceCostSettings($settings: FinanceCostSettingsInput!) {
    updateFinanceCostSettings(settings: $settings) {
      ${FINANCE_COST_SETTINGS_FIELDS}
    }
  }
`;

export const GET_FINANCE_HISTORICAL = gql`
  query GetFinanceHistorical(
    $dateRange: DateRangeInput!
    $costSettings: FinanceCostSettingsInput
  ) {
    getFinanceHistorical(dateRange: $dateRange, costSettings: $costSettings) {
      periods
      granularity
      dateRange {
        from
        to
      }
      warnings
      noData
      error
      appliedCostSettings {
        ${FINANCE_COST_SETTINGS_FIELDS}
      }
      rows {
        metricKey
        label
        format
        emphasis
        values
      }
    }
  }
`;
